import moment from 'moment'

export const toDateWithYear = value => (
  moment(value).format('DD/MM/YYYY')
)
export const toDateWithYearFirst = value => (
  moment(value).format('YYYY-MM-DD')
)
export const toDateWithUnderscore = value => (
  moment(value).format('YYYY_MM_DD')
)
export const customDate = value => (
  moment(value).format('DD/MMM/YYYY')
)
export const tocustomDate = value => (
  moment(value).format('DD-MMM-YYYY')
)
export const toDateYear = value => (
  moment(value).format('DD-MM-YYYY')
)
export const toDateTime = value => (
  moment(value).format('DD/MMM/YYYY h:mm:ss')
)

export const toDateTimeFormat = value => (
  moment(value).format('DD MMM, YYYY h:mm:ss a')
)

export const toDateWithTime = selectedDate => (
  moment(selectedDate).format('DD/MM/YYYY h:mm:ss a')
)
export const toDateWithTimes = selectedDate => (
  moment(selectedDate).format('DD/MM/YYYY h:mm')
)
export const toDateWithCustomTime = selectedDate => (
  moment(selectedDate).format('DD/MM/YYYY h:mm:ss')
)
export const toYearWithDateTime = selectedDate => (
  moment(selectedDate).format('YYYY-MM-DD h:mm:ss a')
)
export const toDateWithDateTime = selectedDate => (
  moment(selectedDate).format('YYYY-MM-DD h:mm:ss')
)

export const toCustomDateTime = dateValue => (
  moment(dateValue).format('Do MMM YYYY h:mm:ss')
)
export const toCustomDate = dateValue => (
  moment(dateValue).format('Do MMM YYYY')
)
export const toDayMonthYear = dateValue => (
  moment(dateValue).format('DD MMM, YYYY')
)
export const toMonthYear = dateValue => {
  const check = moment(dateValue, 'DD/MM/YYYY')
  const month = check.format('MMM')
  const year = check.format('YYYY')
  return month + year
}
export const toDateWithMinute = selectedDate => (
  moment(selectedDate).format('DD/MM/YYYY h:mm a')
)

export const toYearWithDate = selectedDate => {
  if (selectedDate !== null) {
    const splittedDate = selectedDate.split('/')
    const commencementDate = new Date(+splittedDate[2], splittedDate[1] - 1, +splittedDate[0])
    return moment(commencementDate).format('YYYY-MM-DD')
  }
  return ''
}

export const toDateWithMonth = selectedDate => {
  if (selectedDate !== null) {
    const splittedDate = selectedDate.split('-')
    return `${splittedDate[2]}-${splittedDate[1]}-${splittedDate[0]}`
  }
  return ''
}
export const checkDateFormat = dateValue => {
  // eslint-disable-next-line eqeqeq
  if (new Date(dateValue) == 'Invalid Date') {
    const splitDate = dateValue.split(' ')[0]
    const splittedDate = splitDate.split('-')
    return `${splittedDate[2]}-${splittedDate[1]}-${splittedDate[0]}`
  }
  return dateValue
}
export const dateSpecial = dateValue => {
  const dateParts = dateValue.split(' ')
  const date = dateParts[0].split('-')
  return `${date[0]}/${date[1]}/${date[2]}`
}

export const dateDifference = (startDate, endDate) => {
  const start = moment(startDate)
  const end = moment(endDate)
  return end.diff(start, 'days')
}

export const dateTimeDifference = (startDate, endDate) => {
  const diffTime = Math.abs(new Date(endDate).valueOf() - new Date(startDate).valueOf())
  const days = diffTime / (24 * 60 * 60 * 1000)
  const hours = (days % 1) * 24
  const minutes = (hours % 1) * 60
  const secs = ((minutes % 1) * 60) < 1 ? 1 : ((minutes % 1) * 60)
  const [hour, minute, sec] = [Math.floor(hours), Math.floor(minutes), Math.floor(secs)]
  return `${hour}h : ${minute}m : ${sec}s`
}

export const toMonthWithTime = selectedDate => (
  moment(selectedDate).format('MMM Do YYYY, h:mm:ss a')
)
export const toMonthWithYear = selectedDate => (
  moment(selectedDate).format('MMM Do, YYYY')
)

export const toMonthWithYearTime = selectedDate => {
  if (selectedDate !== null) {
    const splittedDate = selectedDate.split('/')
    const commencementDate = new Date(+splittedDate[2], splittedDate[1] - 1, +splittedDate[0])
    return moment(commencementDate).format('MMM DD YYYY, h:mm:ss')
  }
  return ''
}

export const getDate = (date, numOfDays = 1) => {
  const endDate = new Date(date)
  endDate.setDate(endDate.getDate() - Number(numOfDays))
  return moment(endDate).format('DD/MM/YYYY')
}
export const getMinusOneDayDate = (date, numOfDays = 1) => {
  const endDate = new Date(date)
  endDate.setDate(endDate.getDate() - Number(numOfDays))
  return moment(endDate).format('YYYY-MM-DD')
}
export const getDaysInMonth = frequency => {
  if (frequency === 'Month') {
    const today = new Date()
    const year = today.getFullYear()
    const month = today.getMonth() + 1
    const daysInMonth = [31, (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
    return daysInMonth[month - 1]
  }
  return ''
}
export const getDaysInYear = frequency => {
  if (frequency === 'Year') {
    const today = new Date()
    const year = today.getFullYear()
    return (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)) ? 366 : 365
  }
  return ''
}

export const formatSingleDates = (day, month, year) => {
  const inputDateStr = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
  const inputDate = new Date(inputDateStr)
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  if (inputDate > today) {
    return 'Invalid Date, The selected Date cannot be in the future.'
  }
  return inputDateStr
}

export const convertDateString = dateString => {
  const dateObj = new Date(dateString)
  const year = dateObj.getFullYear()
  const month = dateObj.getMonth() + 1
  const day = dateObj.getDate()

  return { year, month, day }
}
export const convertDate = dateString => {
  const dateObj = new Date(dateString)
  const operationYear = dateObj.getFullYear()
  const operationMonth = dateObj.getMonth() + 1
  const operationDay = dateObj.getDate()

  return { operationYear, operationMonth, operationDay }
}
